<div adf-id="{{definition.wid}}" adf-widget-type="{{definition.type}}" ng-class="widgetClasses(widget, definition)" class="ibox float-e-margins">
  <div class="ibox-title" ng-if="!widget.frameless || editMode">
    <h5>{{definition.title}}</h5>
    <div class="ibox-tools">
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_REFRESH') }}" ng-if="widget.reload" ng-click="reload()">
        <i class="glyphicon glyphicon-refresh"></i>
      </a>
      <!-- change widget location -->
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_MOVE') }}" class="adf-move" ng-if="editMode">
        <i class="glyphicon glyphicon-move"></i>
      </a>
      <!-- collapse -->
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_COLLAPSE') }}" ng-show="options.collapsible && !widgetState.isCollapsed" ng-click="widgetState.isCollapsed = !widgetState.isCollapsed">
        <i class="glyphicon glyphicon-minus"></i>
      </a>
      <!-- expand -->
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_EXPAND') }}" ng-show="options.collapsible && widgetState.isCollapsed" ng-click="widgetState.isCollapsed = !widgetState.isCollapsed">
        <i class="glyphicon glyphicon-plus"></i>
      </a>
      <!-- open edit mode -->
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_EDIT') }}" ng-click="edit()" ng-if="editMode">
        <i class="glyphicon glyphicon-cog"></i>
      </a>
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_FULLSCREEN') }}" ng-click="openFullScreen()" ng-show="options.maximizable">
       <i class="glyphicon glyphicon-fullscreen"></i>
      </a>
      <!-- remove widget -->
      <a href="" title="{{ translate('ADF_WIDGET_TOOLTIP_REMOVE') }}" ng-click="remove()" ng-if="editMode">
        <i class="glyphicon glyphicon-remove"></i>
      </a>
    </div>
  </div>

  <div ng-class="{'panel-body':!widget.frameless || editMode}" uib-collapse="widgetState.isCollapsed" class="ibox-content">
    <adf-widget-content model="definition" content="widget" />
  </div>
</div>